<template>
    <div class="ma-4">
        <v-layout row wrap class="pa-2">
              <v-flex xs12>
                <v-btn fab x-small @click="$router.go(-1)">
                  <v-icon>navigate_before</v-icon>
                    
                  </v-btn>
              </v-flex>

              <v-flex xs12>
                <h1 class="text-center mb-5">Locations</h1>
              </v-flex>
              
              

              <v-flex xs12 class="pa-2">
                  <v-data-table
                    :headers="headers"
                    :items="units"
                    sort-by="Name"
                    sort-asc
                    class="elevation-1"
                    :loading="isLoading"
                    loading-text="Loading Locations"
                    

                  >

                  </v-data-table>

              </v-flex>
          </v-layout>
    </div>
</template>
<script>
import axios from 'axios'
// import moment from 'moment'
// import Foot from '../components/Footer'

const url = require("../../client_config/config").url;

  export default {
    components: {
    },
    data: () => ({
    headers: [
      {
        text: 'Name',
        align: 'start',
        sortable: true,
        value: 'Name',
      },
      { text: "Address", value: "Address" },
      { text: "City", value: "City" },
      { text: "State", value: "State" },
      { text: "Zip", value: "Zip" },
    ],
    units: [],
    isLoading: false,
    requiredField: [
        v => !!v || 'This is required',
    ],
    userState: localStorage.getItem('userState')
    }),

    computed: {
      
    },

    created() {
      this.getUnits();
      
    },

    methods: {
      initialize() {
        this.units = [];
      },
      
      getUnits() {
          this.units = []
          this.isLoading = true

          const companyIds = localStorage.getItem('userCompanies');

          axios.get(`${url}/units/state/${this.userState}`, {
            params: {
              Company: JSON.parse(companyIds)
            }
          }).then(res => {
            this.units = res.data.units
            this.isLoading = false
          })
        },
           
      },
      

      
    }
  
</script>
<style>
@media only screen and (max-width: 480px) {

}
</style>